import { SubmissionError } from 'redux-form';

import createAsyncAction from 'shared/utils/createAsyncAction';
import { addToast } from 'modules/messageSystem/actions/addToast';
import { currentModal } from 'modules/messageSystem/selectors';
import { apiErrorHandler } from 'shared/utils/apiErrorHandler';

import createAction from './';
import { updateUser } from './_api/updateUser';
import { getCommonUserConfig } from '../selectors/users';
import {
  apiErrorMessagesMap,
  USER_SECONDARY_KEYS_DUPLICATION_ERROR,
} from '../constants/apiErrorCodes';

export const SUBMIT_EDIT_USER_FORM = createAsyncAction(createAction('SUBMIT_EDIT_USER_FORM'));

export const submitEditUserForm = (data, scrollToError) => (dispatch, getState) => {
  dispatch({ type: SUBMIT_EDIT_USER_FORM.pending });

  return dispatch(updateUser(data))
    .then(() => {
      currentModal(getState()).onOk();

      dispatch({ type: SUBMIT_EDIT_USER_FORM.success });

      return dispatch(addToast('success', 'user-successfully-updated', {
        id: 'MyAccount.Details.DetailsUpdated.Message',
        defaultMessage: '** User details updated successfully',
      }));
    })
    .catch(error => {
      const userConfig = getCommonUserConfig(getState());
      const apiErrorMessageMapMod = { ...apiErrorMessagesMap };
      apiErrorMessageMapMod[USER_SECONDARY_KEYS_DUPLICATION_ERROR].fields = userConfig.secondaryFields;

      throw new SubmissionError(apiErrorHandler(error, true, apiErrorMessagesMap, false, scrollToError));
    });
};
